import { Box, Container } from '@mui/material';
import type { ReactNode } from 'react';
import { TopNav } from './TopNav';

type Props = {
  children: ReactNode;
};

export function PageShell({ children }: Props) {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <TopNav />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {children}
      </Container>
    </Box>
  );
}
